
import { AbstractAccessorService } from "../../common/data-access/abstract-accessor.service";
import { IDataAccessor } from "../../common/data-access/data-accessor";
import { IResponse } from "../../common/data-access/model/response";
import { Token } from "../../common/data-access/model/token";
import type { UrlParams } from "../../dto/url-params";
import { OrigStoreProductType, StoreProductType } from "./StoreProductType";
import { BuilderType, OrigBuilderType } from "./SystemBuilderType";
import { IBuilderUrlService } from "./builder-url";
import type { BuilderUrlParams } from "./builder-url-params";
import { ActionKey } from "./builder-url.config";

export class BuilderUrlService extends AbstractAccessorService<string> implements IBuilderUrlService {
    public readonly $name: string = "builderUrlService";

    public static readonly $inject: string[] = ["$accessor", "$q"];

    constructor(public $accessor: IDataAccessor<string>) { super(); }

    /**
     * 
     * @param token 
     * @param urlParams 
     * @returns 
     ** storeProduct 的URL获取
     */
    public getBuilderUrl(token: Token, urlParams: BuilderUrlParams,isNewBuilderUrl:boolean): angular.IPromise<IResponse<string>> {
        if (isNewBuilderUrl) {
            //* new 地址
            return this.$accessor<string,BuilderUrlParams, ActionKey>(this.$name, "getBuilderUrl", {
                headers: {
                    Authorization: token.token_type + ' ' + token.access_token,
                    "access-control-allow-origin": "*"
                },
                parameter: urlParams
            });
        } 
        else {
            //* 旧有地址
            return this.$accessor<string, BuilderUrlParams, ActionKey>(this.$name, "get", {
                headers: {
                    Authorization: token.token_type + ' ' + token.access_token,
                    "access-control-allow-origin": "*"
                },
                parameter: urlParams
            });
        }

    }


    /**
     * @param urlParams 
     * @returns 获取到Builder URL的 请求参数
     */
    public getBuilderUrlParams(urlParams: UrlParams): BuilderUrlParams {
        let storeProductType, storeProductTypeId, builderType;
        let storeProductId = urlParams.storeProductId;
        let productInstanceId = urlParams.productInstanceId;
        let propertyModelId = urlParams.propertyModelId;
        if ((storeProductId || urlParams.isPreview === "true") && productInstanceId) {
            storeProductType = StoreProductType.PRODUCT_INSTANCE;
            storeProductTypeId = productInstanceId;
            builderType = urlParams.isPreview ? BuilderType.UserPreview : BuilderType.EShop;
        } else if (propertyModelId && storeProductId) {
            storeProductType = StoreProductType.STORE_PRODUCT;
            storeProductTypeId = storeProductId;
            builderType = urlParams.isPreview ? BuilderType.UserPreview : BuilderType.EShop;
        } else {
            if(productInstanceId){
                storeProductType = OrigStoreProductType.PRODUCT_INSTANCE_ID;
                storeProductTypeId = productInstanceId;
            }else if(storeProductId){
                storeProductType = OrigStoreProductType.STORE_PRODUCT_ID;
                storeProductTypeId = storeProductId;
            }else if(propertyModelId){
                storeProductType = OrigStoreProductType.PROPERTY_MODEL_ID;
                storeProductTypeId = propertyModelId;
            }
            builderType = urlParams.isPreview ? OrigBuilderType.UserPreview : OrigBuilderType.Builder;
        }

        let language = urlParams.language ? urlParams.language : "";
        let returnParams: BuilderUrlParams = {
            idType: storeProductType,
            id: storeProductTypeId,
            language: language,
            builderType: builderType
        }
        return returnParams
    }


}
